import React from 'react';

export const FilesEdit = ({ fill = '#252733', width = 16, height = 16 }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9.42841 2.18634C8.95706 2.2333 8.50393 2.46317 8.17454 2.86544L1.76423 10.6943L1.75011 10.8378L1.50435 13.3632L1.46346 13.7323C1.44751 13.8763 1.58508 13.9889 1.72305 13.9449L2.07682 13.832L4.50413 13.0928L4.64203 13.0506L11.0523 5.2218C11.7111 4.41726 11.5962 3.26349 10.7916 2.60472C10.3893 2.27534 9.89977 2.13938 9.42841 2.18634ZM9.51392 3.04463C9.7408 3.02203 9.97978 3.10302 10.2215 3.30096C10.7031 3.69528 10.7504 4.17015 10.3561 4.65171L10.0633 4.9935L8.59348 3.78998L8.87078 3.43553C9.06873 3.19378 9.28703 3.06723 9.51392 3.04463ZM8.02339 4.48622L9.49323 5.68974L4.59048 11.6774C4.23754 11.13 3.72696 10.7119 3.12064 10.4739L8.02339 4.48622ZM2.61665 11.263C3.17832 11.4273 3.64442 11.809 3.9163 12.3272L2.46835 12.7698L2.61665 11.263Z"
            fill={fill}
        />
        <path
            d="M6 13.5C6 13.2239 6.22386 13 6.5 13H13.5C13.7761 13 14 13.2239 14 13.5C14 13.7761 13.7761 14 13.5 14H6.5C6.22386 14 6 13.7761 6 13.5Z"
            fill={fill}
        />
    </svg>
);
